/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as LoginRouteImport } from './pages/login'
import { Route as LayoutRouteImport } from './pages/_layout'
import { Route as R404RouteImport } from './pages/404'
import { Route as LayoutIndexRouteImport } from './pages/_layout.index'
import { Route as LayoutUserRouteImport } from './pages/_layout/user'
import { Route as LayoutSystemRouteImport } from './pages/_layout/system'
import { Route as LayoutReviewRouteImport } from './pages/_layout/review'
import { Route as LayoutPlatformRouteImport } from './pages/_layout/platform'
import { Route as LayoutOprRouteImport } from './pages/_layout/opr'
import { Route as LayoutGoodsRouteImport } from './pages/_layout/goods'
import { Route as LayoutUserIndexRouteImport } from './pages/_layout/user/index'
import { Route as LayoutSystemIndexRouteImport } from './pages/_layout/system/index'
import { Route as LayoutReviewIndexRouteImport } from './pages/_layout/review/index'
import { Route as LayoutPlatformIndexRouteImport } from './pages/_layout/platform/index'
import { Route as LayoutOprIndexRouteImport } from './pages/_layout/opr/index'
import { Route as LayoutGoodsIndexRouteImport } from './pages/_layout/goods/index'
import { Route as LayoutUserInvitationRouteImport } from './pages/_layout/user/invitation'
import { Route as LayoutUserInfluencerRouteImport } from './pages/_layout/user/influencer'
import { Route as LayoutSystemUserDebugRouteImport } from './pages/_layout/system/userDebug'
import { Route as LayoutSystemQunjielongAccountRouteImport } from './pages/_layout/system/qunjielongAccount'
import { Route as LayoutSystemMaterialManagementRouteImport } from './pages/_layout/system/materialManagement'
import { Route as LayoutSystemLoginPhoneRouteImport } from './pages/_layout/system/loginPhone'
import { Route as LayoutSystemCopywritingStyleRouteImport } from './pages/_layout/system/copywritingStyle'
import { Route as LayoutSystemComplianceWordbookRouteImport } from './pages/_layout/system/complianceWordbook'
import { Route as LayoutReviewSelectionRouteImport } from './pages/_layout/review/selection'
import { Route as LayoutReviewInstitutionsRouteImport } from './pages/_layout/review/institutions'
import { Route as LayoutPlatformPopupManagementRouteImport } from './pages/_layout/platform/popupManagement'
import { Route as LayoutOprTraceAuditDetailRouteImport } from './pages/_layout/opr/traceAuditDetail'
import { Route as LayoutOprTraceAuditRouteImport } from './pages/_layout/opr/traceAudit'
import { Route as LayoutOprSpecialEventConfigurationRouteImport } from './pages/_layout/opr/specialEventConfiguration'
import { Route as LayoutOprSelectionCalendarRouteImport } from './pages/_layout/opr/selectionCalendar'
import { Route as LayoutGoodsSelectionShelfRouteImport } from './pages/_layout/goods/selectionShelf'
import { Route as LayoutGoodsSelectionLogRouteImport } from './pages/_layout/goods/selectionLog'
import { Route as LayoutGoodsGoodsLibraryRouteImport } from './pages/_layout/goods/goodsLibrary'
import { Route as LayoutGoodsGoodsDetailRouteImport } from './pages/_layout/goods/goodsDetail'
import { Route as LayoutOprSpecialEventConfigurationIndexRouteImport } from './pages/_layout/opr/specialEventConfiguration/index'
import { Route as LayoutOprSpecialEventConfigurationEditIdRouteImport } from './pages/_layout/opr/specialEventConfiguration/edit.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutUserRoute = LayoutUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSystemRoute = LayoutSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutReviewRoute = LayoutReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPlatformRoute = LayoutPlatformRouteImport.update({
  id: '/platform',
  path: '/platform',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutOprRoute = LayoutOprRouteImport.update({
  id: '/opr',
  path: '/opr',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutGoodsRoute = LayoutGoodsRouteImport.update({
  id: '/goods',
  path: '/goods',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutUserIndexRoute = LayoutUserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutUserRoute,
} as any)
const LayoutSystemIndexRoute = LayoutSystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutSystemRoute,
} as any)
const LayoutReviewIndexRoute = LayoutReviewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutReviewRoute,
} as any)
const LayoutPlatformIndexRoute = LayoutPlatformIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutPlatformRoute,
} as any)
const LayoutOprIndexRoute = LayoutOprIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutOprRoute,
} as any)
const LayoutGoodsIndexRoute = LayoutGoodsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutGoodsRoute,
} as any)
const LayoutUserInvitationRoute = LayoutUserInvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => LayoutUserRoute,
} as any)
const LayoutUserInfluencerRoute = LayoutUserInfluencerRouteImport.update({
  id: '/influencer',
  path: '/influencer',
  getParentRoute: () => LayoutUserRoute,
} as any)
const LayoutSystemUserDebugRoute = LayoutSystemUserDebugRouteImport.update({
  id: '/userDebug',
  path: '/userDebug',
  getParentRoute: () => LayoutSystemRoute,
} as any)
const LayoutSystemQunjielongAccountRoute =
  LayoutSystemQunjielongAccountRouteImport.update({
    id: '/qunjielongAccount',
    path: '/qunjielongAccount',
    getParentRoute: () => LayoutSystemRoute,
  } as any)
const LayoutSystemMaterialManagementRoute =
  LayoutSystemMaterialManagementRouteImport.update({
    id: '/materialManagement',
    path: '/materialManagement',
    getParentRoute: () => LayoutSystemRoute,
  } as any)
const LayoutSystemLoginPhoneRoute = LayoutSystemLoginPhoneRouteImport.update({
  id: '/loginPhone',
  path: '/loginPhone',
  getParentRoute: () => LayoutSystemRoute,
} as any)
const LayoutSystemCopywritingStyleRoute =
  LayoutSystemCopywritingStyleRouteImport.update({
    id: '/copywritingStyle',
    path: '/copywritingStyle',
    getParentRoute: () => LayoutSystemRoute,
  } as any)
const LayoutSystemComplianceWordbookRoute =
  LayoutSystemComplianceWordbookRouteImport.update({
    id: '/complianceWordbook',
    path: '/complianceWordbook',
    getParentRoute: () => LayoutSystemRoute,
  } as any)
const LayoutReviewSelectionRoute = LayoutReviewSelectionRouteImport.update({
  id: '/selection',
  path: '/selection',
  getParentRoute: () => LayoutReviewRoute,
} as any)
const LayoutReviewInstitutionsRoute =
  LayoutReviewInstitutionsRouteImport.update({
    id: '/institutions',
    path: '/institutions',
    getParentRoute: () => LayoutReviewRoute,
  } as any)
const LayoutPlatformPopupManagementRoute =
  LayoutPlatformPopupManagementRouteImport.update({
    id: '/popupManagement',
    path: '/popupManagement',
    getParentRoute: () => LayoutPlatformRoute,
  } as any)
const LayoutOprTraceAuditDetailRoute =
  LayoutOprTraceAuditDetailRouteImport.update({
    id: '/traceAuditDetail',
    path: '/traceAuditDetail',
    getParentRoute: () => LayoutOprRoute,
  } as any)
const LayoutOprTraceAuditRoute = LayoutOprTraceAuditRouteImport.update({
  id: '/traceAudit',
  path: '/traceAudit',
  getParentRoute: () => LayoutOprRoute,
} as any)
const LayoutOprSpecialEventConfigurationRoute =
  LayoutOprSpecialEventConfigurationRouteImport.update({
    id: '/specialEventConfiguration',
    path: '/specialEventConfiguration',
    getParentRoute: () => LayoutOprRoute,
  } as any)
const LayoutOprSelectionCalendarRoute =
  LayoutOprSelectionCalendarRouteImport.update({
    id: '/selectionCalendar',
    path: '/selectionCalendar',
    getParentRoute: () => LayoutOprRoute,
  } as any)
const LayoutGoodsSelectionShelfRoute =
  LayoutGoodsSelectionShelfRouteImport.update({
    id: '/selectionShelf',
    path: '/selectionShelf',
    getParentRoute: () => LayoutGoodsRoute,
  } as any)
const LayoutGoodsSelectionLogRoute = LayoutGoodsSelectionLogRouteImport.update({
  id: '/selectionLog',
  path: '/selectionLog',
  getParentRoute: () => LayoutGoodsRoute,
} as any)
const LayoutGoodsGoodsLibraryRoute = LayoutGoodsGoodsLibraryRouteImport.update({
  id: '/goodsLibrary',
  path: '/goodsLibrary',
  getParentRoute: () => LayoutGoodsRoute,
} as any)
const LayoutGoodsGoodsDetailRoute = LayoutGoodsGoodsDetailRouteImport.update({
  id: '/goodsDetail',
  path: '/goodsDetail',
  getParentRoute: () => LayoutGoodsRoute,
} as any)
const LayoutOprSpecialEventConfigurationIndexRoute =
  LayoutOprSpecialEventConfigurationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutOprSpecialEventConfigurationRoute,
  } as any)
const LayoutOprSpecialEventConfigurationEditIdRoute =
  LayoutOprSpecialEventConfigurationEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => LayoutOprSpecialEventConfigurationRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/404': typeof R404Route
  '/': typeof LayoutIndexRoute
  '/login': typeof LoginRoute
  '/goods': typeof LayoutGoodsRouteWithChildren
  '/opr': typeof LayoutOprRouteWithChildren
  '/platform': typeof LayoutPlatformRouteWithChildren
  '/review': typeof LayoutReviewRouteWithChildren
  '/system': typeof LayoutSystemRouteWithChildren
  '/user': typeof LayoutUserRouteWithChildren
  '/goods/goodsDetail': typeof LayoutGoodsGoodsDetailRoute
  '/goods/goodsLibrary': typeof LayoutGoodsGoodsLibraryRoute
  '/goods/selectionLog': typeof LayoutGoodsSelectionLogRoute
  '/goods/selectionShelf': typeof LayoutGoodsSelectionShelfRoute
  '/opr/selectionCalendar': typeof LayoutOprSelectionCalendarRoute
  '/opr/specialEventConfiguration': typeof LayoutOprSpecialEventConfigurationRouteWithChildren
  '/opr/traceAudit': typeof LayoutOprTraceAuditRoute
  '/opr/traceAuditDetail': typeof LayoutOprTraceAuditDetailRoute
  '/platform/popupManagement': typeof LayoutPlatformPopupManagementRoute
  '/review/institutions': typeof LayoutReviewInstitutionsRoute
  '/review/selection': typeof LayoutReviewSelectionRoute
  '/system/complianceWordbook': typeof LayoutSystemComplianceWordbookRoute
  '/system/copywritingStyle': typeof LayoutSystemCopywritingStyleRoute
  '/system/loginPhone': typeof LayoutSystemLoginPhoneRoute
  '/system/materialManagement': typeof LayoutSystemMaterialManagementRoute
  '/system/qunjielongAccount': typeof LayoutSystemQunjielongAccountRoute
  '/system/userDebug': typeof LayoutSystemUserDebugRoute
  '/user/influencer': typeof LayoutUserInfluencerRoute
  '/user/invitation': typeof LayoutUserInvitationRoute
  '/goods/': typeof LayoutGoodsIndexRoute
  '/opr/': typeof LayoutOprIndexRoute
  '/platform/': typeof LayoutPlatformIndexRoute
  '/review/': typeof LayoutReviewIndexRoute
  '/system/': typeof LayoutSystemIndexRoute
  '/user/': typeof LayoutUserIndexRoute
  '/opr/specialEventConfiguration/': typeof LayoutOprSpecialEventConfigurationIndexRoute
  '/opr/specialEventConfiguration/edit/$id': typeof LayoutOprSpecialEventConfigurationEditIdRoute
}
export interface FileRoutesByTo {
  '/404': typeof R404Route
  '/login': typeof LoginRoute
  '/': typeof LayoutIndexRoute
  '/goods/goodsDetail': typeof LayoutGoodsGoodsDetailRoute
  '/goods/goodsLibrary': typeof LayoutGoodsGoodsLibraryRoute
  '/goods/selectionLog': typeof LayoutGoodsSelectionLogRoute
  '/goods/selectionShelf': typeof LayoutGoodsSelectionShelfRoute
  '/opr/selectionCalendar': typeof LayoutOprSelectionCalendarRoute
  '/opr/traceAudit': typeof LayoutOprTraceAuditRoute
  '/opr/traceAuditDetail': typeof LayoutOprTraceAuditDetailRoute
  '/platform/popupManagement': typeof LayoutPlatformPopupManagementRoute
  '/review/institutions': typeof LayoutReviewInstitutionsRoute
  '/review/selection': typeof LayoutReviewSelectionRoute
  '/system/complianceWordbook': typeof LayoutSystemComplianceWordbookRoute
  '/system/copywritingStyle': typeof LayoutSystemCopywritingStyleRoute
  '/system/loginPhone': typeof LayoutSystemLoginPhoneRoute
  '/system/materialManagement': typeof LayoutSystemMaterialManagementRoute
  '/system/qunjielongAccount': typeof LayoutSystemQunjielongAccountRoute
  '/system/userDebug': typeof LayoutSystemUserDebugRoute
  '/user/influencer': typeof LayoutUserInfluencerRoute
  '/user/invitation': typeof LayoutUserInvitationRoute
  '/goods': typeof LayoutGoodsIndexRoute
  '/opr': typeof LayoutOprIndexRoute
  '/platform': typeof LayoutPlatformIndexRoute
  '/review': typeof LayoutReviewIndexRoute
  '/system': typeof LayoutSystemIndexRoute
  '/user': typeof LayoutUserIndexRoute
  '/opr/specialEventConfiguration': typeof LayoutOprSpecialEventConfigurationIndexRoute
  '/opr/specialEventConfiguration/edit/$id': typeof LayoutOprSpecialEventConfigurationEditIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/404': typeof R404Route
  '/_layout': typeof LayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/_layout/goods': typeof LayoutGoodsRouteWithChildren
  '/_layout/opr': typeof LayoutOprRouteWithChildren
  '/_layout/platform': typeof LayoutPlatformRouteWithChildren
  '/_layout/review': typeof LayoutReviewRouteWithChildren
  '/_layout/system': typeof LayoutSystemRouteWithChildren
  '/_layout/user': typeof LayoutUserRouteWithChildren
  '/_layout/': typeof LayoutIndexRoute
  '/_layout/goods/goodsDetail': typeof LayoutGoodsGoodsDetailRoute
  '/_layout/goods/goodsLibrary': typeof LayoutGoodsGoodsLibraryRoute
  '/_layout/goods/selectionLog': typeof LayoutGoodsSelectionLogRoute
  '/_layout/goods/selectionShelf': typeof LayoutGoodsSelectionShelfRoute
  '/_layout/opr/selectionCalendar': typeof LayoutOprSelectionCalendarRoute
  '/_layout/opr/specialEventConfiguration': typeof LayoutOprSpecialEventConfigurationRouteWithChildren
  '/_layout/opr/traceAudit': typeof LayoutOprTraceAuditRoute
  '/_layout/opr/traceAuditDetail': typeof LayoutOprTraceAuditDetailRoute
  '/_layout/platform/popupManagement': typeof LayoutPlatformPopupManagementRoute
  '/_layout/review/institutions': typeof LayoutReviewInstitutionsRoute
  '/_layout/review/selection': typeof LayoutReviewSelectionRoute
  '/_layout/system/complianceWordbook': typeof LayoutSystemComplianceWordbookRoute
  '/_layout/system/copywritingStyle': typeof LayoutSystemCopywritingStyleRoute
  '/_layout/system/loginPhone': typeof LayoutSystemLoginPhoneRoute
  '/_layout/system/materialManagement': typeof LayoutSystemMaterialManagementRoute
  '/_layout/system/qunjielongAccount': typeof LayoutSystemQunjielongAccountRoute
  '/_layout/system/userDebug': typeof LayoutSystemUserDebugRoute
  '/_layout/user/influencer': typeof LayoutUserInfluencerRoute
  '/_layout/user/invitation': typeof LayoutUserInvitationRoute
  '/_layout/goods/': typeof LayoutGoodsIndexRoute
  '/_layout/opr/': typeof LayoutOprIndexRoute
  '/_layout/platform/': typeof LayoutPlatformIndexRoute
  '/_layout/review/': typeof LayoutReviewIndexRoute
  '/_layout/system/': typeof LayoutSystemIndexRoute
  '/_layout/user/': typeof LayoutUserIndexRoute
  '/_layout/opr/specialEventConfiguration/': typeof LayoutOprSpecialEventConfigurationIndexRoute
  '/_layout/opr/specialEventConfiguration/edit/$id': typeof LayoutOprSpecialEventConfigurationEditIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/404'
    | '/'
    | '/login'
    | '/goods'
    | '/opr'
    | '/platform'
    | '/review'
    | '/system'
    | '/user'
    | '/goods/goodsDetail'
    | '/goods/goodsLibrary'
    | '/goods/selectionLog'
    | '/goods/selectionShelf'
    | '/opr/selectionCalendar'
    | '/opr/specialEventConfiguration'
    | '/opr/traceAudit'
    | '/opr/traceAuditDetail'
    | '/platform/popupManagement'
    | '/review/institutions'
    | '/review/selection'
    | '/system/complianceWordbook'
    | '/system/copywritingStyle'
    | '/system/loginPhone'
    | '/system/materialManagement'
    | '/system/qunjielongAccount'
    | '/system/userDebug'
    | '/user/influencer'
    | '/user/invitation'
    | '/goods/'
    | '/opr/'
    | '/platform/'
    | '/review/'
    | '/system/'
    | '/user/'
    | '/opr/specialEventConfiguration/'
    | '/opr/specialEventConfiguration/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/404'
    | '/login'
    | '/'
    | '/goods/goodsDetail'
    | '/goods/goodsLibrary'
    | '/goods/selectionLog'
    | '/goods/selectionShelf'
    | '/opr/selectionCalendar'
    | '/opr/traceAudit'
    | '/opr/traceAuditDetail'
    | '/platform/popupManagement'
    | '/review/institutions'
    | '/review/selection'
    | '/system/complianceWordbook'
    | '/system/copywritingStyle'
    | '/system/loginPhone'
    | '/system/materialManagement'
    | '/system/qunjielongAccount'
    | '/system/userDebug'
    | '/user/influencer'
    | '/user/invitation'
    | '/goods'
    | '/opr'
    | '/platform'
    | '/review'
    | '/system'
    | '/user'
    | '/opr/specialEventConfiguration'
    | '/opr/specialEventConfiguration/edit/$id'
  id:
    | '__root__'
    | '/404'
    | '/_layout'
    | '/login'
    | '/_layout/goods'
    | '/_layout/opr'
    | '/_layout/platform'
    | '/_layout/review'
    | '/_layout/system'
    | '/_layout/user'
    | '/_layout/'
    | '/_layout/goods/goodsDetail'
    | '/_layout/goods/goodsLibrary'
    | '/_layout/goods/selectionLog'
    | '/_layout/goods/selectionShelf'
    | '/_layout/opr/selectionCalendar'
    | '/_layout/opr/specialEventConfiguration'
    | '/_layout/opr/traceAudit'
    | '/_layout/opr/traceAuditDetail'
    | '/_layout/platform/popupManagement'
    | '/_layout/review/institutions'
    | '/_layout/review/selection'
    | '/_layout/system/complianceWordbook'
    | '/_layout/system/copywritingStyle'
    | '/_layout/system/loginPhone'
    | '/_layout/system/materialManagement'
    | '/_layout/system/qunjielongAccount'
    | '/_layout/system/userDebug'
    | '/_layout/user/influencer'
    | '/_layout/user/invitation'
    | '/_layout/goods/'
    | '/_layout/opr/'
    | '/_layout/platform/'
    | '/_layout/review/'
    | '/_layout/system/'
    | '/_layout/user/'
    | '/_layout/opr/specialEventConfiguration/'
    | '/_layout/opr/specialEventConfiguration/edit/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  R404Route: typeof R404Route
  LayoutRoute: typeof LayoutRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/user': {
      id: '/_layout/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof LayoutUserRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/system': {
      id: '/_layout/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof LayoutSystemRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/review': {
      id: '/_layout/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof LayoutReviewRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/platform': {
      id: '/_layout/platform'
      path: '/platform'
      fullPath: '/platform'
      preLoaderRoute: typeof LayoutPlatformRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/opr': {
      id: '/_layout/opr'
      path: '/opr'
      fullPath: '/opr'
      preLoaderRoute: typeof LayoutOprRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/goods': {
      id: '/_layout/goods'
      path: '/goods'
      fullPath: '/goods'
      preLoaderRoute: typeof LayoutGoodsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/user/': {
      id: '/_layout/user/'
      path: '/'
      fullPath: '/user/'
      preLoaderRoute: typeof LayoutUserIndexRouteImport
      parentRoute: typeof LayoutUserRoute
    }
    '/_layout/system/': {
      id: '/_layout/system/'
      path: '/'
      fullPath: '/system/'
      preLoaderRoute: typeof LayoutSystemIndexRouteImport
      parentRoute: typeof LayoutSystemRoute
    }
    '/_layout/review/': {
      id: '/_layout/review/'
      path: '/'
      fullPath: '/review/'
      preLoaderRoute: typeof LayoutReviewIndexRouteImport
      parentRoute: typeof LayoutReviewRoute
    }
    '/_layout/platform/': {
      id: '/_layout/platform/'
      path: '/'
      fullPath: '/platform/'
      preLoaderRoute: typeof LayoutPlatformIndexRouteImport
      parentRoute: typeof LayoutPlatformRoute
    }
    '/_layout/opr/': {
      id: '/_layout/opr/'
      path: '/'
      fullPath: '/opr/'
      preLoaderRoute: typeof LayoutOprIndexRouteImport
      parentRoute: typeof LayoutOprRoute
    }
    '/_layout/goods/': {
      id: '/_layout/goods/'
      path: '/'
      fullPath: '/goods/'
      preLoaderRoute: typeof LayoutGoodsIndexRouteImport
      parentRoute: typeof LayoutGoodsRoute
    }
    '/_layout/user/invitation': {
      id: '/_layout/user/invitation'
      path: '/invitation'
      fullPath: '/user/invitation'
      preLoaderRoute: typeof LayoutUserInvitationRouteImport
      parentRoute: typeof LayoutUserRoute
    }
    '/_layout/user/influencer': {
      id: '/_layout/user/influencer'
      path: '/influencer'
      fullPath: '/user/influencer'
      preLoaderRoute: typeof LayoutUserInfluencerRouteImport
      parentRoute: typeof LayoutUserRoute
    }
    '/_layout/system/userDebug': {
      id: '/_layout/system/userDebug'
      path: '/userDebug'
      fullPath: '/system/userDebug'
      preLoaderRoute: typeof LayoutSystemUserDebugRouteImport
      parentRoute: typeof LayoutSystemRoute
    }
    '/_layout/system/qunjielongAccount': {
      id: '/_layout/system/qunjielongAccount'
      path: '/qunjielongAccount'
      fullPath: '/system/qunjielongAccount'
      preLoaderRoute: typeof LayoutSystemQunjielongAccountRouteImport
      parentRoute: typeof LayoutSystemRoute
    }
    '/_layout/system/materialManagement': {
      id: '/_layout/system/materialManagement'
      path: '/materialManagement'
      fullPath: '/system/materialManagement'
      preLoaderRoute: typeof LayoutSystemMaterialManagementRouteImport
      parentRoute: typeof LayoutSystemRoute
    }
    '/_layout/system/loginPhone': {
      id: '/_layout/system/loginPhone'
      path: '/loginPhone'
      fullPath: '/system/loginPhone'
      preLoaderRoute: typeof LayoutSystemLoginPhoneRouteImport
      parentRoute: typeof LayoutSystemRoute
    }
    '/_layout/system/copywritingStyle': {
      id: '/_layout/system/copywritingStyle'
      path: '/copywritingStyle'
      fullPath: '/system/copywritingStyle'
      preLoaderRoute: typeof LayoutSystemCopywritingStyleRouteImport
      parentRoute: typeof LayoutSystemRoute
    }
    '/_layout/system/complianceWordbook': {
      id: '/_layout/system/complianceWordbook'
      path: '/complianceWordbook'
      fullPath: '/system/complianceWordbook'
      preLoaderRoute: typeof LayoutSystemComplianceWordbookRouteImport
      parentRoute: typeof LayoutSystemRoute
    }
    '/_layout/review/selection': {
      id: '/_layout/review/selection'
      path: '/selection'
      fullPath: '/review/selection'
      preLoaderRoute: typeof LayoutReviewSelectionRouteImport
      parentRoute: typeof LayoutReviewRoute
    }
    '/_layout/review/institutions': {
      id: '/_layout/review/institutions'
      path: '/institutions'
      fullPath: '/review/institutions'
      preLoaderRoute: typeof LayoutReviewInstitutionsRouteImport
      parentRoute: typeof LayoutReviewRoute
    }
    '/_layout/platform/popupManagement': {
      id: '/_layout/platform/popupManagement'
      path: '/popupManagement'
      fullPath: '/platform/popupManagement'
      preLoaderRoute: typeof LayoutPlatformPopupManagementRouteImport
      parentRoute: typeof LayoutPlatformRoute
    }
    '/_layout/opr/traceAuditDetail': {
      id: '/_layout/opr/traceAuditDetail'
      path: '/traceAuditDetail'
      fullPath: '/opr/traceAuditDetail'
      preLoaderRoute: typeof LayoutOprTraceAuditDetailRouteImport
      parentRoute: typeof LayoutOprRoute
    }
    '/_layout/opr/traceAudit': {
      id: '/_layout/opr/traceAudit'
      path: '/traceAudit'
      fullPath: '/opr/traceAudit'
      preLoaderRoute: typeof LayoutOprTraceAuditRouteImport
      parentRoute: typeof LayoutOprRoute
    }
    '/_layout/opr/specialEventConfiguration': {
      id: '/_layout/opr/specialEventConfiguration'
      path: '/specialEventConfiguration'
      fullPath: '/opr/specialEventConfiguration'
      preLoaderRoute: typeof LayoutOprSpecialEventConfigurationRouteImport
      parentRoute: typeof LayoutOprRoute
    }
    '/_layout/opr/selectionCalendar': {
      id: '/_layout/opr/selectionCalendar'
      path: '/selectionCalendar'
      fullPath: '/opr/selectionCalendar'
      preLoaderRoute: typeof LayoutOprSelectionCalendarRouteImport
      parentRoute: typeof LayoutOprRoute
    }
    '/_layout/goods/selectionShelf': {
      id: '/_layout/goods/selectionShelf'
      path: '/selectionShelf'
      fullPath: '/goods/selectionShelf'
      preLoaderRoute: typeof LayoutGoodsSelectionShelfRouteImport
      parentRoute: typeof LayoutGoodsRoute
    }
    '/_layout/goods/selectionLog': {
      id: '/_layout/goods/selectionLog'
      path: '/selectionLog'
      fullPath: '/goods/selectionLog'
      preLoaderRoute: typeof LayoutGoodsSelectionLogRouteImport
      parentRoute: typeof LayoutGoodsRoute
    }
    '/_layout/goods/goodsLibrary': {
      id: '/_layout/goods/goodsLibrary'
      path: '/goodsLibrary'
      fullPath: '/goods/goodsLibrary'
      preLoaderRoute: typeof LayoutGoodsGoodsLibraryRouteImport
      parentRoute: typeof LayoutGoodsRoute
    }
    '/_layout/goods/goodsDetail': {
      id: '/_layout/goods/goodsDetail'
      path: '/goodsDetail'
      fullPath: '/goods/goodsDetail'
      preLoaderRoute: typeof LayoutGoodsGoodsDetailRouteImport
      parentRoute: typeof LayoutGoodsRoute
    }
    '/_layout/opr/specialEventConfiguration/': {
      id: '/_layout/opr/specialEventConfiguration/'
      path: '/'
      fullPath: '/opr/specialEventConfiguration/'
      preLoaderRoute: typeof LayoutOprSpecialEventConfigurationIndexRouteImport
      parentRoute: typeof LayoutOprSpecialEventConfigurationRoute
    }
    '/_layout/opr/specialEventConfiguration/edit/$id': {
      id: '/_layout/opr/specialEventConfiguration/edit/$id'
      path: '/edit/$id'
      fullPath: '/opr/specialEventConfiguration/edit/$id'
      preLoaderRoute: typeof LayoutOprSpecialEventConfigurationEditIdRouteImport
      parentRoute: typeof LayoutOprSpecialEventConfigurationRoute
    }
  }
}

interface LayoutGoodsRouteChildren {
  LayoutGoodsGoodsDetailRoute: typeof LayoutGoodsGoodsDetailRoute
  LayoutGoodsGoodsLibraryRoute: typeof LayoutGoodsGoodsLibraryRoute
  LayoutGoodsSelectionLogRoute: typeof LayoutGoodsSelectionLogRoute
  LayoutGoodsSelectionShelfRoute: typeof LayoutGoodsSelectionShelfRoute
  LayoutGoodsIndexRoute: typeof LayoutGoodsIndexRoute
}

const LayoutGoodsRouteChildren: LayoutGoodsRouteChildren = {
  LayoutGoodsGoodsDetailRoute: LayoutGoodsGoodsDetailRoute,
  LayoutGoodsGoodsLibraryRoute: LayoutGoodsGoodsLibraryRoute,
  LayoutGoodsSelectionLogRoute: LayoutGoodsSelectionLogRoute,
  LayoutGoodsSelectionShelfRoute: LayoutGoodsSelectionShelfRoute,
  LayoutGoodsIndexRoute: LayoutGoodsIndexRoute,
}

const LayoutGoodsRouteWithChildren = LayoutGoodsRoute._addFileChildren(
  LayoutGoodsRouteChildren,
)

interface LayoutOprSpecialEventConfigurationRouteChildren {
  LayoutOprSpecialEventConfigurationIndexRoute: typeof LayoutOprSpecialEventConfigurationIndexRoute
  LayoutOprSpecialEventConfigurationEditIdRoute: typeof LayoutOprSpecialEventConfigurationEditIdRoute
}

const LayoutOprSpecialEventConfigurationRouteChildren: LayoutOprSpecialEventConfigurationRouteChildren =
  {
    LayoutOprSpecialEventConfigurationIndexRoute:
      LayoutOprSpecialEventConfigurationIndexRoute,
    LayoutOprSpecialEventConfigurationEditIdRoute:
      LayoutOprSpecialEventConfigurationEditIdRoute,
  }

const LayoutOprSpecialEventConfigurationRouteWithChildren =
  LayoutOprSpecialEventConfigurationRoute._addFileChildren(
    LayoutOprSpecialEventConfigurationRouteChildren,
  )

interface LayoutOprRouteChildren {
  LayoutOprSelectionCalendarRoute: typeof LayoutOprSelectionCalendarRoute
  LayoutOprSpecialEventConfigurationRoute: typeof LayoutOprSpecialEventConfigurationRouteWithChildren
  LayoutOprTraceAuditRoute: typeof LayoutOprTraceAuditRoute
  LayoutOprTraceAuditDetailRoute: typeof LayoutOprTraceAuditDetailRoute
  LayoutOprIndexRoute: typeof LayoutOprIndexRoute
}

const LayoutOprRouteChildren: LayoutOprRouteChildren = {
  LayoutOprSelectionCalendarRoute: LayoutOprSelectionCalendarRoute,
  LayoutOprSpecialEventConfigurationRoute:
    LayoutOprSpecialEventConfigurationRouteWithChildren,
  LayoutOprTraceAuditRoute: LayoutOprTraceAuditRoute,
  LayoutOprTraceAuditDetailRoute: LayoutOprTraceAuditDetailRoute,
  LayoutOprIndexRoute: LayoutOprIndexRoute,
}

const LayoutOprRouteWithChildren = LayoutOprRoute._addFileChildren(
  LayoutOprRouteChildren,
)

interface LayoutPlatformRouteChildren {
  LayoutPlatformPopupManagementRoute: typeof LayoutPlatformPopupManagementRoute
  LayoutPlatformIndexRoute: typeof LayoutPlatformIndexRoute
}

const LayoutPlatformRouteChildren: LayoutPlatformRouteChildren = {
  LayoutPlatformPopupManagementRoute: LayoutPlatformPopupManagementRoute,
  LayoutPlatformIndexRoute: LayoutPlatformIndexRoute,
}

const LayoutPlatformRouteWithChildren = LayoutPlatformRoute._addFileChildren(
  LayoutPlatformRouteChildren,
)

interface LayoutReviewRouteChildren {
  LayoutReviewInstitutionsRoute: typeof LayoutReviewInstitutionsRoute
  LayoutReviewSelectionRoute: typeof LayoutReviewSelectionRoute
  LayoutReviewIndexRoute: typeof LayoutReviewIndexRoute
}

const LayoutReviewRouteChildren: LayoutReviewRouteChildren = {
  LayoutReviewInstitutionsRoute: LayoutReviewInstitutionsRoute,
  LayoutReviewSelectionRoute: LayoutReviewSelectionRoute,
  LayoutReviewIndexRoute: LayoutReviewIndexRoute,
}

const LayoutReviewRouteWithChildren = LayoutReviewRoute._addFileChildren(
  LayoutReviewRouteChildren,
)

interface LayoutSystemRouteChildren {
  LayoutSystemComplianceWordbookRoute: typeof LayoutSystemComplianceWordbookRoute
  LayoutSystemCopywritingStyleRoute: typeof LayoutSystemCopywritingStyleRoute
  LayoutSystemLoginPhoneRoute: typeof LayoutSystemLoginPhoneRoute
  LayoutSystemMaterialManagementRoute: typeof LayoutSystemMaterialManagementRoute
  LayoutSystemQunjielongAccountRoute: typeof LayoutSystemQunjielongAccountRoute
  LayoutSystemUserDebugRoute: typeof LayoutSystemUserDebugRoute
  LayoutSystemIndexRoute: typeof LayoutSystemIndexRoute
}

const LayoutSystemRouteChildren: LayoutSystemRouteChildren = {
  LayoutSystemComplianceWordbookRoute: LayoutSystemComplianceWordbookRoute,
  LayoutSystemCopywritingStyleRoute: LayoutSystemCopywritingStyleRoute,
  LayoutSystemLoginPhoneRoute: LayoutSystemLoginPhoneRoute,
  LayoutSystemMaterialManagementRoute: LayoutSystemMaterialManagementRoute,
  LayoutSystemQunjielongAccountRoute: LayoutSystemQunjielongAccountRoute,
  LayoutSystemUserDebugRoute: LayoutSystemUserDebugRoute,
  LayoutSystemIndexRoute: LayoutSystemIndexRoute,
}

const LayoutSystemRouteWithChildren = LayoutSystemRoute._addFileChildren(
  LayoutSystemRouteChildren,
)

interface LayoutUserRouteChildren {
  LayoutUserInfluencerRoute: typeof LayoutUserInfluencerRoute
  LayoutUserInvitationRoute: typeof LayoutUserInvitationRoute
  LayoutUserIndexRoute: typeof LayoutUserIndexRoute
}

const LayoutUserRouteChildren: LayoutUserRouteChildren = {
  LayoutUserInfluencerRoute: LayoutUserInfluencerRoute,
  LayoutUserInvitationRoute: LayoutUserInvitationRoute,
  LayoutUserIndexRoute: LayoutUserIndexRoute,
}

const LayoutUserRouteWithChildren = LayoutUserRoute._addFileChildren(
  LayoutUserRouteChildren,
)

interface LayoutRouteChildren {
  LayoutGoodsRoute: typeof LayoutGoodsRouteWithChildren
  LayoutOprRoute: typeof LayoutOprRouteWithChildren
  LayoutPlatformRoute: typeof LayoutPlatformRouteWithChildren
  LayoutReviewRoute: typeof LayoutReviewRouteWithChildren
  LayoutSystemRoute: typeof LayoutSystemRouteWithChildren
  LayoutUserRoute: typeof LayoutUserRouteWithChildren
  LayoutIndexRoute: typeof LayoutIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutGoodsRoute: LayoutGoodsRouteWithChildren,
  LayoutOprRoute: LayoutOprRouteWithChildren,
  LayoutPlatformRoute: LayoutPlatformRouteWithChildren,
  LayoutReviewRoute: LayoutReviewRouteWithChildren,
  LayoutSystemRoute: LayoutSystemRouteWithChildren,
  LayoutUserRoute: LayoutUserRouteWithChildren,
  LayoutIndexRoute: LayoutIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  R404Route: R404Route,
  LayoutRoute: LayoutRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
